export const msalConfig = {
  auth: {
    clientId: "de329301-d464-4655-ba91-a299e1aa3ea5",
    authority: "https://b2cprodgovmt.b2clogin.com/b2cprodgovmt.onmicrosoft.com/B2C_1A_PROD_OB_SHARED_CORPAAD_EXT_SIGNIN",
    knownAuthorities: ["b2cprodgovmt.b2clogin.com"],
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [
    "https://b2cprodgovmt.onmicrosoft.com/ProjectGreen-Intranet/user_impersonation"
  ],
};